import { Card, Skeleton, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Organism, OrganismFrame } from '@/core/architecture'

export const ArtistStoreCollectionBoxSkeleton: Organism<{ width?: number }> = ({
  width,
}) => (
  <OrganismFrame>
    <Card elevation={0} sx={{ bgcolor: 'transparent', borderRadius: 0, width }}>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={90}
        sx={{ borderRadius: 1 }}
      />
      <Stack spacing={1}>
        <SkeletonText variant="subtitle1" />
        <SkeletonText variant="caption" width="50%" />
      </Stack>
    </Card>
  </OrganismFrame>
)
